
// js/custom-element/section/product-facet/product-facet.js
var ProductFacet = class extends CustomHTMLElement {
    connectedCallback() {
      this.delegate.on("pagination:page-changed", this._rerender.bind(this));
      this.delegate.on("facet:criteria-changed", this._rerender.bind(this));
      this.delegate.on("facet:abort-loading", this._abort.bind(this));
    }
    async _rerender(event) {
      history.replaceState({}, "", event.detail.url);
      this._abort();
      this.showLoadingBar();
      const url = new URL(window.location);
      let thisSelector = this;
      let sectionId = this.getAttribute("section-id");
      const tabsFilterSectionID = document.querySelector(".section-plp-tabs-filters")?.closest('.shopify-section').id?.replace("shopify-section-", "");

      if (!sectionId) {
        const mainCollectionSection = document.querySelector(".shopify-section--main-collection");

        if (mainCollectionSection && mainCollectionSection.id) {
          sectionId = mainCollectionSection.id.replace("shopify-section-", "");
          thisSelector = document.querySelector(`#${mainCollectionSection.id} product-facet`);
        }
      }

      url.searchParams.delete("section_id");
      url.searchParams.set("sections", `${sectionId},${tabsFilterSectionID}`);

      try {
        this.abortController = new AbortController();
        const response = await fetch(url.toString(), { signal: this.abortController.signal });
        const responseAsJson = await response.json();

        // --- Update main collection (facet) ---
        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = responseAsJson[sectionId];
        thisSelector.querySelector("#facet-main").innerHTML = fakeDiv.querySelector("#facet-main").innerHTML;

        // Toolbar filter update
        const activeFilterList = Array.from(fakeDiv.querySelectorAll(".product-facet__active-list"));
        const toolbarItem = document.querySelector(".mobile-toolbar__item--filters");
        toolbarItem?.classList.toggle("has-filters", activeFilterList.length > 0);

        // Preserve collapsible state & scroll
        const filtersTempDiv = fakeDiv.querySelector("#facet-filters");
        if (filtersTempDiv) {
          const previousScrollTop = thisSelector.querySelector("#facet-filters .drawer__content").scrollTop;
          Array.from(thisSelector.querySelectorAll("#facet-filters-form .collapsible-toggle[aria-controls]")).forEach((filterToggle) => {
            const filtersTempDivToggle = filtersTempDiv.querySelector(`[aria-controls="${filterToggle.getAttribute("aria-controls")}"]`), isExpanded = filterToggle.getAttribute("aria-expanded") === "true";
            filtersTempDivToggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
            filtersTempDivToggle.nextElementSibling.toggleAttribute("open", isExpanded);
            filtersTempDivToggle.nextElementSibling.style.overflow = isExpanded ? "visible" : "";
          });
          thisSelector.querySelector("#facet-filters").innerHTML = filtersTempDiv.innerHTML;
          thisSelector.querySelector("#facet-filters .drawer__content").scrollTop = previousScrollTop;
        }

        // --- Update PLP tabs filters ---
        const plpTabsFiltersSortByInput = document.querySelector("#section-plp-tabs-filters__sort-by-sync");
        const plpTabsFiltersSortByNewValue = fakeDiv.querySelector("#sort-by-popover :checked")?.value;

        if (plpTabsFiltersSortByInput && plpTabsFiltersSortByNewValue) {
          plpTabsFiltersSortByInput.value = plpTabsFiltersSortByNewValue;
        }

        if (responseAsJson[tabsFilterSectionID]) {
          const tabsContainer = document.querySelector(`#shopify-section-${tabsFilterSectionID}`);
          if (tabsContainer) {
            const fakeTabsDiv = document.createElement("div");
            fakeTabsDiv.innerHTML = responseAsJson[tabsFilterSectionID];
            const newItems = fakeTabsDiv.querySelectorAll(".section-plp-tabs-filters__item");

            // Replace content of existing items
            const existingItems = tabsContainer.querySelectorAll(".section-plp-tabs-filters__item");
            existingItems.forEach((item, index) => {
              if (newItems[index]) {
                item.innerHTML = newItems[index].innerHTML;
              }
            });
          }
        }

        // Scroll smoothly to main content
        const scrollTo = thisSelector.querySelector(".product-facet__meta-bar") || thisSelector.querySelector(".product-facet__product-list") || thisSelector.querySelector(".product-facet__main");

        requestAnimationFrame(() => {
          scrollTo.scrollIntoView({ block: "start", behavior: "smooth" });
        });

        this.hideLoadingBar();
      } catch (e) {
        if (e.name === "AbortError") {
          return;
        }
      }
    }
    _abort() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
};
window.customElements.define("product-facet", ProductFacet);